import { catalogApi } from './catalog-api';
import { surfaceApi } from './surface-api';
import { surfaceAssetsApi } from './surface-assets-api';
import { externalNetworkAssetFilterOptionsApi } from './external-network-asset-filter-options-api';
import { surfaceScansApi } from './surface-scans-api';
import { surfaceSettingsApi } from './surface-settings-api';
import { internalNetworkAssetsApi } from './internal-network-assets-api';
import { internalNetworkAdEntitiesApi } from './internal-network-ad-entities-api';
import { createPortalApi } from './portal-api';
import { createTargetScopeApi } from './target-scope-api';

type TargetScopeDeps = {
  countFindingsByFilter: ReturnType<
    typeof createPortalApi
  >['countFindingsByFilter'];
  getSignalsCountByApplicationId: ReturnType<
    typeof createPortalApi
  >['getSignalsCountByApplicationId'];
  getSignalsByApplication: ReturnType<
    typeof createPortalApi
  >['getSignalsByApplication'];
  countSurfaceSignals: typeof surfaceApi.countSurfaceSignals;
  listSurfaceSignals: typeof surfaceApi.listSurfaceSignals;
};

export function createTerraProxyApiClient() {
  const portalApi = createPortalApi();

  const baseClient = {
    ...catalogApi,
    ...surfaceApi,
    ...surfaceAssetsApi,
    ...externalNetworkAssetFilterOptionsApi,
    ...surfaceScansApi,
    ...surfaceSettingsApi,
    ...internalNetworkAssetsApi,
    ...internalNetworkAdEntitiesApi,
    ...portalApi,
  };

  const targetScopeDeps: TargetScopeDeps = {
    countFindingsByFilter: baseClient.countFindingsByFilter.bind(baseClient),
    getSignalsCountByApplicationId:
      baseClient.getSignalsCountByApplicationId.bind(baseClient),
    getSignalsByApplication:
      baseClient.getSignalsByApplication.bind(baseClient),
    countSurfaceSignals: baseClient.countSurfaceSignals.bind(baseClient),
    listSurfaceSignals: baseClient.listSurfaceSignals.bind(baseClient),
  };

  return {
    ...baseClient,
    ...createTargetScopeApi(targetScopeDeps),
  };
}

export const terraProxyApiClient = createTerraProxyApiClient();

export type TerraProxyApiClient = typeof terraProxyApiClient;
